import { render, staticRenderFns } from "./invoice-params.vue?vue&type=template&id=a4fe4046&scoped=true"
import script from "./invoice-params.vue?vue&type=script&lang=js"
export * from "./invoice-params.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fe4046",
  null
  
)

export default component.exports